(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand_menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const viewer = document.querySelector(".SmartPhone-brand-Viewer");
    const mainbrand = viewer.querySelector(".main-brand_in, .main-brand_out");
    const subbrand = viewer.querySelector(".sub-brand_out, .sub-brand_in");
    const backButton = viewer.querySelector(".brand-menu-back-button");
    const backLabel = backButton.querySelector("span");
  
    // カテゴリーボタンを押したら sub-brand へスライド
    viewer.querySelectorAll("button[data-brand]").forEach(button => {
      button.addEventListener("click", () => {
        const brand = button.getAttribute("data-brand");
  
        // 戻るボタンのラベルを動的に変更
        backLabel.textContent = brand;
  
        // クラスの切り替えでスライド
        mainbrand.classList.remove("main-brand_in");
        mainbrand.classList.add("main-brand_out");
  
        subbrand.classList.remove("sub-brand_out");
        subbrand.classList.add("sub-brand_in");
  
        // 該当のサブカテゴリだけ表示
        subbrand.querySelectorAll("div[data-bigbrand]").forEach(sub => {
          const isActive = sub.getAttribute("data-bigbrand") === brand;
          sub.classList.toggle("active", isActive);
        });
      });
    });
  
    // 戻るボタンで main-brand に戻る
    backButton.addEventListener("click", () => {
      mainbrand.classList.remove("main-brand_out");
      mainbrand.classList.add("main-brand_in");
  
      subbrand.classList.remove("sub-brand_in");
      subbrand.classList.add("sub-brand_out");
  
      subbrand.querySelectorAll("div[data-bigbrand]").forEach(sub => {
        sub.classList.remove("active");
      });
    });

    const tabButtons = document.querySelectorAll(".brand-pc-tab");
    const tabContents = document.querySelectorAll(".brand-pc-content");
  
    tabButtons.forEach(button => {
      button.addEventListener("click", () => {
        const brand = button.getAttribute("data-pcbrand");
  
        // タブ切り替え
        tabButtons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");
  
        // コンテンツ表示切り替え
        tabContents.forEach(content => {
          content.classList.toggle("active", content.getAttribute("data-pcbrand") === brand);
        });
      });
    });

    const scrollContainer = document.querySelector(".pc-brand-tabs");
    const leftBtn = document.querySelector(".pc-brand-tab-scroll-btn.pc-brand-tab-left");
    const rightBtn = document.querySelector(".pc-brand-tab-scroll-btn.pc-brand-tab-right");
  
    // 最初の .brand-pc-tab 要素の幅を取得（1つ分の幅）
    let tab = scrollContainer.querySelector(".brand-pc-tab");
    let tabWidth = tab ? tab.offsetWidth : 200; // fallback
  
    leftBtn.addEventListener("click", () => {
      tab = scrollContainer.querySelector(".brand-pc-tab");
      tabWidth = tab ? tab.offsetWidth : 200; // fallback
      scrollContainer.scrollBy({ left: -tabWidth-4, behavior: "smooth" });
    });
  
    rightBtn.addEventListener("click", () => {
      tab = scrollContainer.querySelector(".brand-pc-tab");
      tabWidth = tab ? tab.offsetWidth : 200; // fallback
      scrollContainer.scrollBy({ left: tabWidth+4, behavior: "smooth" });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category_menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const viewer = document.querySelector(".SmartPhone-Category-Viewer");
    const mainCategory = viewer.querySelector(".main-category_in, .main-category_out");
    const subCategory = viewer.querySelector(".sub-category_out, .sub-category_in");
    const backButton = viewer.querySelector(".category-menu-back-button");
    const backLabel = backButton.querySelector("span");
  
    // カテゴリーボタンを押したら sub-category へスライド
    viewer.querySelectorAll("button[data-category]").forEach(button => {
      button.addEventListener("click", () => {
        const category = button.getAttribute("data-category");

        /* ★ 1️⃣ 置換用のクリーンな文字列を作る（<br>, &lt;br&gt; → ・） */
        const cleanedLabel = category.replace(/(<br\s*\/?>|&lt;br\s*\/?&gt;)/gi, "・");
  
        // 戻るボタンのラベルを動的に変更
        backLabel.textContent = cleanedLabel;
  
        // クラスの切り替えでスライド
        mainCategory.classList.remove("main-category_in");
        mainCategory.classList.add("main-category_out");
  
        subCategory.classList.remove("sub-category_out");
        subCategory.classList.add("sub-category_in");
  
        // 該当のサブカテゴリだけ表示
        subCategory.querySelectorAll("div[data-bigcategory]").forEach(sub => {
          const isActive = sub.getAttribute("data-bigcategory") === category;
          sub.classList.toggle("active", isActive);
        });
      });
    });
  
    // 戻るボタンで main-category に戻る
    backButton.addEventListener("click", () => {
      mainCategory.classList.remove("main-category_out");
      mainCategory.classList.add("main-category_in");
  
      subCategory.classList.remove("sub-category_in");
      subCategory.classList.add("sub-category_out");
  
      subCategory.querySelectorAll("div[data-bigcategory]").forEach(sub => {
        sub.classList.remove("active");
      });
    });

    const tabButtons = document.querySelectorAll(".pc-tab");
    const tabContents = document.querySelectorAll(".pc-content");
  
    tabButtons.forEach(button => {
      button.addEventListener("click", () => {
        const category = button.getAttribute("data-pccategory");
  
        // タブ切り替え
        tabButtons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");
  
        // コンテンツ表示切り替え
        tabContents.forEach(content => {
          content.classList.toggle("active", content.getAttribute("data-pccategory") === category);
        });
      });
    });

    const scrollContainer = document.querySelector(".pc-category-tabs");
    const leftBtn = document.querySelector(".pc-category-tab-scroll-btn.pc-category-tab-left");
    const rightBtn = document.querySelector(".pc-category-tab-scroll-btn.pc-category-tab-right");
  
    // 最初の .pc-tab 要素の幅を取得（1つ分の幅）
    let tab = scrollContainer.querySelector(".pc-tab");
    let tabWidth = tab ? tab.offsetWidth : 200; // fallback
  
    leftBtn.addEventListener("click", () => {
      tab = scrollContainer.querySelector(".pc-tab");
      tabWidth = tab ? tab.offsetWidth : 200; // fallback
      scrollContainer.scrollBy({ left: -tabWidth-4, behavior: "smooth" });
    });
  
    rightBtn.addEventListener("click", () => {
      tab = scrollContainer.querySelector(".pc-tab");
      tabWidth = tab ? tab.offsetWidth : 200; // fallback
      scrollContainer.scrollBy({ left: tabWidth+4, behavior: "smooth" });
    });
  });


  } catch(e) { console.error(e); }
})();
})();
